/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsThreadColor
 */
export interface MelcoModelsThreadColor {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsThreadColor
     */
    argb?: string | null;
}

export function MelcoModelsThreadColorFromJSON(json: any): MelcoModelsThreadColor {
    return MelcoModelsThreadColorFromJSONTyped(json, false);
}

export function MelcoModelsThreadColorFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsThreadColor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'argb': !exists(json, 'argb') ? undefined : json['argb'],
    };
}

export function MelcoModelsThreadColorToJSON(value?: MelcoModelsThreadColor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'argb': value.argb,
    };
}


